import { DESCRIPTION_SCROLLED } from '../avatarActions'
import { getTourData } from 'aria-viewer/analytics/utils/analyticUtils'
import { trackEvent } from 'aria-viewer/core/middleware/analyticsMiddleware'
import * as EVENTS from 'aria-viewer/analytics/constants'

const avatarAnalytics = {
    [DESCRIPTION_SCROLLED]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)

        return trackEvent(EVENTS.DESCRIPTION_SCROLLED, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
        })
    },
}

export default avatarAnalytics
